import {
  userTeamTaskComputed,
  layoutComputed,
  sideLinksComputed,
  teamTaskComputed,
  kanbanComputed,
  commentsComputed,
  userHistoryComputed,
  urlQueriesComputed,
  invoiceDataComputed,
  searchComboDataComputed,
  ListsComputed,
  userComputed,
  productComputed,
  profileComputed,
  superAdminComputed,
} from '../state/helpers'
import {
  userTeamTaskMethods,
  layoutMethods,
  notificationMethods,
  sideLinksMethods,
  teamTaskMethods,
  kanbanMethods,
  commentMethods,
  userHistoryMethods,
  urlQueriesMethods,
  invoiceMethods,
  searchComboMethods,
  ListsMethods,
  userMethods,
  productMethods,
  profileMethods,
  superAdminMethods,
} from '../state/helpers'

const productMixins = {
  computed: {
    ...productComputed,
  },
  methods: {
    ...productMethods,
  },
}
const userTeamMixins = {
  computed: {
    ...userTeamTaskComputed,
  },
  methods: {
    ...userTeamTaskMethods,
  },
}
const userProfileMixins = {
  computed: {
    ...profileComputed,
  },
  methods: {
    ...profileMethods,
  },
}
const layoutMixins = {
  computed: {
    ...layoutComputed,
  },
  methods: {
    ...layoutMethods,
  },
}

const notifMixins = {
  methods: {
    ...notificationMethods,
  },
}

const sideNavMixins = {
  computed: {
    ...sideLinksComputed,
  },
  methods: {
    ...sideLinksMethods,
  },
}

const teamTaskMixins = {
  computed: {
    ...teamTaskComputed,
  },
  methods: {
    ...teamTaskMethods,
  },
}
const kanbanMixins = {
  computed: {
    ...kanbanComputed,
  },
  methods: {
    ...kanbanMethods,
  },
}

const commentMixins = {
  computed: {
    ...commentsComputed,
  },
  methods: {
    ...commentMethods,
  },
}

const userHistoryMixins = {
  computed: {
    ...userHistoryComputed,
  },
  methods: {
    ...userHistoryMethods,
  },
}

const urlQueriesMixins = {
  computed: {
    ...urlQueriesComputed,
  },
  methods: {
    ...urlQueriesMethods,
  },
}

const invoiceMixins = {
  getters: {
    ...invoiceDataComputed,
  },
  setters: {
    ...invoiceMethods,
  },
}

const searchComboMixins = {
  computed: {
    ...searchComboDataComputed,
  },
  methods: {
    ...searchComboMethods,
  },
}

const ListsMixins = {
  computed: {
    ...ListsComputed,
  },
  methods: {
    ...ListsMethods,
  },
}

const userMixins = {
  computed: {
    ...userComputed,
  },
  methods: {
    ...userMethods,
  },
}
const superAdminMixins = {
  computed: {
    ...superAdminComputed,
  },
  methods: {
    ...superAdminMethods,
  },
}

export {
  userTeamMixins,
  layoutMixins,
  notifMixins,
  sideNavMixins,
  teamTaskMixins,
  kanbanMixins,
  commentMixins,
  userHistoryMixins,
  urlQueriesMixins,
  invoiceMixins,
  searchComboMixins,
  ListsMixins,
  userMixins,
  productMixins,
  userProfileMixins,
  superAdminMixins,
}
